document.addEventListener('DOMContentLoaded', function() {
  return true;

});
  function validateLicense(url) {
    return true;
  }

  document.addEventListener('DOMContentLoaded', syncGiftAddonFromCart);
document.addEventListener('shopify:section:load', syncGiftAddonFromCart);

async function syncGiftAddonFromCart() {
  const giftVariantId = 53451050483976; // replace with real Gift Message Card variant ID
  const reloadFlag = 'gift-addon-auto-sync';

  async function getCart() {
    const res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });
    return await res.json();
  }

  function cartNeedsGiftAddon(cart) {
    return cart.items.some(function(item) {
      return item.properties && item.properties['Gift Message Card'] === 'Yes';
    });
  }

  function cartHasGiftAddon(cart) {
    return cart.items.some(function(item) {
      return Number(item.variant_id) === Number(giftVariantId);
    });
  }

  function getGiftAddonItem(cart) {
    return cart.items.find(function(item) {
      return Number(item.variant_id) === Number(giftVariantId);
    });
  }

  try {
    if (sessionStorage.getItem(reloadFlag) === '1') {
      sessionStorage.removeItem(reloadFlag);
      return;
    }

    const cart = await getCart();
    const needsGiftAddon = cartNeedsGiftAddon(cart);
    const hasGiftAddon = cartHasGiftAddon(cart);

    console.log('Cart needs gift addon:', needsGiftAddon);
    console.log('Cart already has gift addon:', hasGiftAddon);
    console.log('Gift variant ID:', giftVariantId);

    if (needsGiftAddon && !hasGiftAddon) {
      sessionStorage.setItem(reloadFlag, '1');

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(giftVariantId),
          quantity: 1
        })
      });

      const addText = await addRes.text();
      console.log('Gift addon add response:', addText);

      if (!addRes.ok) {
        sessionStorage.removeItem(reloadFlag);
        console.error('Gift add-on add failed:', addText);
        return;
      }

      window.location.reload();
      return;
    }

    if (!needsGiftAddon && hasGiftAddon) {
      const giftItem = getGiftAddonItem(cart);

      if (giftItem) {
        sessionStorage.setItem(reloadFlag, '1');

        const removeRes = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            id: giftItem.key,
            quantity: 0
          })
        });

        const removeText = await removeRes.text();
        console.log('Gift addon remove response:', removeText);

        if (!removeRes.ok) {
          sessionStorage.removeItem(reloadFlag);
          console.error('Gift add-on remove failed:', removeText);
          return;
        }

        window.location.reload();
      }
    }
  } catch (error) {
    console.error('Gift addon auto-sync error:', error);
    sessionStorage.removeItem(reloadFlag);
  }
}

/* optional: run again shortly after add-to-cart clicks */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('button[type="submit"], .personalise-add-btn, [name="add"]');
  if (!btn) return;

  setTimeout(function() {
    syncGiftAddonFromCart();
  }, 1500);
});
